import React from "react"
import styled from "styled-components"

export const Content = ({ children }) => {
  return <Main>{children}</Main>
}

const Main = styled.main`
  min-width: 0;
`
